import { useState } from "react";
import CustomTooltip from "../../../../../../../../components/CustomTooltip";
import Flex from "../../../../../../../../components/Flex";
import Text from "../../../../../../../../components/Text";
import useDisclosure from "../../../../../../../../hooks/use-disclosure";
import { DEFAULT_KEY_LABEL_COLOR } from "../../../../../../../../utils/utils";
import UpsertDiagnosesDrawer from "../../diagnoses/UpsertDiagnosisDrawer";
import ActionableHoverNew from "../ActionableHoverNew";
import { RightAction } from "../PatientRecords";
import { DiagnosisOptions } from "./SummaryConstant";
import { DiagnosisTooltip } from "./encounterTooltips/DiagnosisTooltip";
import { useArchiveState } from "../../../../../../../../hooks/useArchiveState";
import { useArchivePatientDiagnosesMutation } from "../../../../../../../../queries/diagnoses/use-patient-diagnoses-archive";
import DeleteModal from "../../../../../../../../components/app/DeleteModal";
import { useQueryClient } from "@tanstack/react-query";
import LoadingAndEmptyStateWrapper from "./commonWrappers/LoadingAndEmptyStateWrapper";
import { useRecordsScroll } from "./RecordsScrollContext";
interface props {
  diagnosisList: any;
  loading: boolean;
}

const Diagnosis = ({ diagnosisList, loading }: props) => {
  const upsertDiagnosisDisc = useDisclosure();
  const [disabledTooltips, setDisabledTooltips] = useState<{
    [key: number]: boolean;
  }>({});

  const { mutateAsync: archiveDiagnosis } =
    useArchivePatientDiagnosesMutation();
  const queryClient = useQueryClient();
  const { archiveHandler, deleteDisc } = useArchiveState(archiveDiagnosis);
  const { isScrolling } = useRecordsScroll();

  const clickHandler = (v: string, idx: number) => {
    if (v === "Edit") {
      const selectedDiagnosis = diagnosisList?.data?.content[idx];
      const transformedRow = {
        ...selectedDiagnosis,
        medicalCode: selectedDiagnosis?.medicalCode
          ? {
              uuid: selectedDiagnosis.medicalCode.uuid,
              code: `${selectedDiagnosis.medicalCode.code} - ${selectedDiagnosis.medicalCode?.description}`,
            }
          : undefined,
      };
      upsertDiagnosisDisc.open(transformedRow);
    }
    // if (v === "exportToNote") {
    // }
    if (v === "delete") {
      deleteDisc.open(diagnosisList?.data?.content[idx]?.uuid);
    }
  };

  const handleActionAreaToggle = (idx: number, isHovered: boolean) => {
    setDisabledTooltips((prev) => ({ ...prev, [idx]: isHovered }));
  };

  const handleMenuToggle = (idx: number, isOpen: boolean) => {
    setDisabledTooltips((prev) => ({ ...prev, [idx]: isOpen }));
  };
  return (
    <>
      <DeleteModal
        w="380px"
        open={deleteDisc.opened}
        onClose={deleteDisc.close}
        id={deleteDisc.deleteId}
        onConfirmation={(id) =>
          archiveHandler(true, id).then((res) => {
            queryClient.invalidateQueries({
              queryKey: ["patient-diagnoses-list"],
            });
            return res;
          })
        }
        content={`You want to Delete this Diagnosis`}
      />
      <Flex flexDirection={"column"} width={"100%"}>
        <UpsertDiagnosesDrawer disclosureHost={upsertDiagnosisDisc} />
        <LoadingAndEmptyStateWrapper
          loading={loading}
          isEmpty={diagnosisList?.data?.content?.length === 0}
          emptyMessage="No Diagnoses found"
        />
        {diagnosisList?.data?.content?.map((it: any, idx: number) => {
          const isTooltipDisabled = disabledTooltips[idx] || false;
          return (
            <Flex key={idx} width={"100%"}>
              <CustomTooltip
                key={it?.medicalCode?.code}
                content={<DiagnosisTooltip key={idx} data={it} />}
                position="right"
                disableTooltip={isTooltipDisabled || isScrolling}
              >
                <ActionableHoverNew
                  renderAction={
                    <div
                      onMouseEnter={() => handleActionAreaToggle(idx, true)}
                      onMouseLeave={() => handleActionAreaToggle(idx, false)}
                    >
                      <RightAction
                        handleClickOption={(v) => clickHandler(v, idx)}
                        menuList={DiagnosisOptions}
                        onMenuOpen={() => handleMenuToggle(idx, true)}
                        onMenuClose={() => handleMenuToggle(idx, false)}
                      />
                    </div>
                  }
                >
                  <Flex flexDirection={"column"} width={"100%"} gap={2}>
                    <Text isTabletext color={DEFAULT_KEY_LABEL_COLOR}>
                      {idx + 1}. {it?.medicalCode?.code}{" "}
                      {it?.medicalCode?.description?.slice(0, 30)}...
                    </Text>
                  </Flex>
                </ActionableHoverNew>
              </CustomTooltip>
            </Flex>
          );
        })}
      </Flex>
    </>
  );
};

export default Diagnosis;
